import { post, type RequestConfig } from "../shared/api-client";
import {
  JIVANDHARA_BASE,
  isApiItemResponse,
  unwrapItem,
} from "../admin/list-api-helpers";
import {
  parseHealthcareCreateOrderResponse,
  parseHealthcareVerifyPaymentResponse,
  type HealthcareCreateOrderPayload,
  type HealthcareCreateOrderResult,
  type HealthcareVerifyPaymentPayload,
  type HealthcareVerifyPaymentResult,
} from "@project/types/healthcare-donation";

const SILENT: RequestConfig = { showNotification: false };
const DONATIONS_BASE = `${JIVANDHARA_BASE}/healthcare-donations`;

class PublicHealthcareDonationService {
  createOrder = async (
    payload: HealthcareCreateOrderPayload
  ): Promise<HealthcareCreateOrderResult> => {
    const response = await post<unknown, HealthcareCreateOrderPayload>(
      `${DONATIONS_BASE}/create-order/`,
      payload,
      SILENT
    );
    const parsed = parseHealthcareCreateOrderResponse(
      unwrapItem(response) ?? (response as object)
    );
    if (!parsed.order_id) {
      throw new Error("Failed to create healthcare payment order.");
    }
    return parsed;
  };

  verifyPayment = async (
    payload: HealthcareVerifyPaymentPayload
  ): Promise<HealthcareVerifyPaymentResult> => {
    const response = await post<unknown, HealthcareVerifyPaymentPayload>(
      `${DONATIONS_BASE}/verify-payment/`,
      payload,
      SILENT
    );
    if (isApiItemResponse(response)) {
      return parseHealthcareVerifyPaymentResponse(response.data ?? response);
    }
    return parseHealthcareVerifyPaymentResponse(
      (unwrapItem(response) ?? response) as HealthcareVerifyPaymentResult
    );
  };
}

export const publicHealthcareDonationService =
  new PublicHealthcareDonationService();
